import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { PreferenzaAgenzia } from 'src/app/models/preferenza-agenzia';
import { BaseEditForm } from 'src/app/shared/baseEditForm';

@Component({
  selector: 'edit-preferenza-agenzia',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditPreferenzaAgenziaComponent extends BaseEditForm implements OnInit {

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<EditPreferenzaAgenziaComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: PreferenzaAgenzia,
  ) {
    super();
  }

  ngOnInit() {
    this.form = this.fb.group({
      agenzia: [this.data?.agenzia, Validators.required],
      incaricato: [this.data?.incaricato, Validators.required],
    });
  }

}
